import * as React from "react";
import { ReactNode } from "react";

export default function SettingsPanel({ children, id }: { children: ReactNode; id?: string }) {
  return (
    <div className="panel with-shadow" id={id}>
      <div className="settings react-form">{children}</div>
    </div>
  );
}
